{
  "status": {
    "provisioning": "Provisionando",
    "active": "Ativo",
    "suspended": "Suspenso",
    "cancelled": "Cancelado"
  },
  "checkingSession": "Verificando sessão…",
  "login": {
    "error": "Não foi possível entrar.",
    "title": "Painel da plataforma",
    "subtitle": "Acesso restrito à equipe da Xtreed.",
    "email": "Email",
    "password": "Senha",
    "submit": "Entrar"
  },
  "panel": {
    "errors": {
      "generic": "Não foi possível concluir."
    },
    "toast": {
      "created": "Área de membros criada em {{url}}",
      "statusUpdated": "Status atualizado."
    },
    "badge": "Plataforma",
    "logout": "Sair",
    "title": "Clientes",
    "count_one": "{{count}} área de membros",
    "count_zero": "{{count}} áreas de membros",
    "count_other": "{{count}} áreas de membros",
    "newClient": "Novo cliente",
    "loading": "Carregando…",
    "features": "Recursos",
    "reactivate": "Reativar",
    "suspend": "Suspender"
  },
  "form": {
    "name": "Nome",
    "namePlaceholder": "Escola do João",
    "slug": "Identificador",
    "slugPlaceholder": "escola-do-joao",
    "adminEmail": "E-mail do admin",
    "adminEmailPlaceholder": "admin@escola.com",
    "adminName": "Nome do admin",
    "adminNamePlaceholder": "João Silva",
    "adminPassword": "Senha inicial",
    "submit": "Criar"
  },
  "features": {
    "community": "Comunidade",
    "certificates": "Certificados",
    "gamification": "Gamificação",
    "assistant": "Assistente de IA",
    "toast": {
      "updated": "Plano atualizado.",
      "error": "Não foi possível salvar."
    },
    "loading": "Carregando recursos…",
    "includedInPlan": "Incluído no plano",
    "enabledByClient": "· ligado pelo cliente",
    "disabledByClient": "· desligado pelo cliente"
  }
}
